import Cookies from 'js-cookie';

import { Availability } from 'app/interfaces/common';

/*
 * Get Availability based on app configuration
 * @return {Availability}
 */
export const getSiteAvailability = (): Availability => {
  // Allow the killswitch to be bypassed for production verification
  if (Cookies.get('GAK.ignoreKillSwitch')?.trim().toUpperCase() === 'TRUE') {
    return Availability.Open;
  }

  if (window.CONFIG.killswitch) {
    return window.CONFIG.softClosureState;
  }

  // Perform date check to see if application is within valid redemption round
  const softOpenTime = new Date(window.CONFIG.softOpenTime);
  const softCloseTime = new Date(window.CONFIG.softCloseTime);
  const now = new Date();
  const outOfRange = now < softOpenTime || now > softCloseTime;

  // Return closure state - Homepage will redirect to according template
  if (outOfRange) {
    return window.CONFIG.softClosureState;
  }

  return Availability.Open;
};

export async function checkAvailability(): Promise<{ status: Availability }> {
  const siteAvailability = getSiteAvailability();

  if (siteAvailability !== Availability.Open) {
    return {
      status: siteAvailability
    };
  }

  return {
    status: Availability.Open
  };
}
